module.exports = __webpack_public_path__ + "static/media/bg-profile.2d19a74c.png";